import * as React from 'react';
import * as styles from './styles.css';
import { ArticleHeading4, ArticleParagraph1 } from '@cian/ui-kit';

export const NotFound: React.FC = () => {
  return (
    <div className={styles['container']}>
      <ArticleHeading4 color="gray40_100">Ничего не найдено</ArticleHeading4>
      <div className={styles['text']}>
        <ArticleParagraph1 color="gray40_100">Попробуйте изменить поиск</ArticleParagraph1>
      </div>
    </div>
  );
};

NotFound.displayName = 'NotFound';
